import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-delta',
  templateUrl: './icon-delta.component.html',
  styleUrl: './icon-delta.component.scss',
  standalone: false
})
export class IconDeltaComponent {
  @Input() tooltip?: string;
}
